import { Link } from 'react-router-dom';
import { CaretLeft, Info } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import {
  useMobilePageHeaderBackAction,
  useMobilePageHeaderTrailingAction,
} from '../../store/MobilePageHeaderContext';

/** `back` / `trailing` — 40×40, $radius-ds-md, ícone 20 em $fg-muted. */
const SLOT_CLASS =
  'flex h-10 w-10 shrink-0 items-center justify-center rounded-ds-md text-muted-foreground transition-colors hover:bg-muted';

/**
 * `ds/nav/top-bar--mobile--back` — modo "voltar" do topo mobile: linha de 56
 * (voltar · título centrado $type-display-stat · acção) e legenda opcional
 * ($type-label, centrada) por baixo.
 */
export function MobileRouteHeader({ title, backTo }) {
  const trailing = useMobilePageHeaderTrailingAction();
  const backAction = useMobilePageHeaderBackAction();

  return (
    <header className="fixed inset-x-0 top-0 z-30 flex flex-col border-b border-border bg-card">
      <div className="flex h-14 w-full items-center gap-space-3 px-space-4">
        {backAction?.onClick ? (
          <button
            type="button"
            onClick={backAction.onClick}
            className={SLOT_CLASS}
            aria-label={pt.nav.back}
          >
            <CaretLeft className="h-5 w-5" weight="regular" aria-hidden />
          </button>
        ) : (
          <Link to={backTo} className={SLOT_CLASS} aria-label={pt.nav.back}>
            <CaretLeft className="h-5 w-5" weight="regular" aria-hidden />
          </Link>
        )}
        <h1 className="min-w-0 flex-1 truncate text-center font-display text-type-display-stat font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {trailing?.label ? (
          <button
            type="button"
            onClick={trailing.onClick}
            className={SLOT_CLASS}
            aria-label={trailing.ariaLabel || trailing.label}
            title={trailing.label}
          >
            <Info className="h-5 w-5" aria-hidden />
          </button>
        ) : (
          <span className="h-10 w-10 shrink-0" aria-hidden />
        )}
      </div>
      {trailing?.label ? (
        <p className="w-full px-space-4 pb-space-2 text-center text-type-label font-normal text-muted-foreground">
          {trailing.label}
        </p>
      ) : null}
    </header>
  );
}
